import { IVI } from '../../enums/rnec/rnec.enum';

export class RnecResponseDto {
  public constructor(
    public ivi: IVI,
    public mensaje: string,
    public validacion: boolean,
    public soporteDigital: string = null,
    public soporteParentesco: string = null,
    public relacionParentesco: string = null
  ) {}
}
